import React, { useState, useEffect } from "react";
import "./Switch.scss";
import { Icon, Stack, Button, Row } from "_core/components/common/UI";

const Switch = (props) => {
    const [currentState, setCurrentState] = useState(props.value);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        if (!props.options)
        {
            return
        }
        setCurrentIndex(getIndex(currentState));
    }, [currentState]);

    useEffect(() => {
        console.log("valueをセット :" + props.value);
        setCurrentState(props.value)
    }, [props.value]);

    const getIndex = (value) => {
        if (!props.options) {
            return 0;
        }
        const index = props.options.findIndex(option => option.value === value);
        return index >= 0 ? index : 0;
    }

    const onChangeState = (newState) => {
        if (props.disabled) {
            // 非活性時は切り替えない
            return;
        }

        if (newState === currentState) {
            // 新しい状態が現在の状態と同じ場合は何もしない
            return;
        }

        setCurrentState(newState);
        if (props.onChange) {
            props.onChange(newState);
        }
    }

    return (
        <div className={"row-stack switch spacing-4px value-" + props.value + (props.disabled ? " disabled" : "") + " " + props.className} style={{"--cursor-index" : String(currentIndex)}}>
            {
                props.options &&
                props.options.map((option) => {
                    const isChecked = (option.value === currentState);
                    return (
                        <Button key={option.value} className="hidden" onClick={() => {onChangeState(option.value)}} disabled={props.disabled}>
                            <Stack className={`icon flex-center align-center width-full icon-right ${isChecked ? "" : "inactive"}`}>
                                <Icon icon={option.icon} size={20} />
                            </Stack>
                        </Button>
                    )
                })
            }
            <div className="cursor"></div>
        </div>
    );
};

export default Switch;
